import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AiEmailTemplatesDropdown",
  props: {
    showLoadOption: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const handleOpenModal = action => {
      if (action === "load" && !props.showLoadOption) {
        return;
      }
      emit("open-modal", action);
    };
    return {
      handleOpenModal
    };
  }
});